import * as React from "react";
import { TabsContent, Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Plus } from "lucide-react";
import { Searchbar } from "../ui/searchbar";
import OverviewCards from "./sections/OverviewCards";
import StudentsSection from "./sections/StudentsSection";
import UploadSection from "./sections/upload/UploadSection";
import ResourcesSection from "./sections/ResourcesSection";
import NotificationModal from "./sections/NotificationModal";
import AssignmentsSection from "./sections/AssignmentsSection";
import InterviewSection from "./sections/InterviewSection";
import ResizableSections from "../Ranking/ResizableSections";
import { useNavigate } from "react-router-dom";

const InstructorDashboard = () => {
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [resources] = React.useState([
    { id: 1, title: "Introduction to React", type: "pdf" },
    { id: 2, title: "TypeScript Basics", type: "video" },
  ]);

  return (
    <div className="min-h-screen bg-background px-4 sm:px-6 md:px-8 py-6">
      <div className=" mx-auto space-y-6">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="space-y-1 text-center sm:text-left">
            <h1 className="text-2xl sm:text-3xl font-bold dark:text-foreground">
              Instructor Dashboard
            </h1>
            <p className="text-sm sm:text-base text-slate-500">
              Manage your students and course content
            </p>
          </div>

          {/* Add Notification Button */}
          <div className="flex">
          <button
            className="flex items-center justify-center gap-1 border px-4 py-2 rounded-lg 
                       dark:bg-white bg-black text-white dark:text-black text-sm 
                       hover:opacity-90 transition-all w-full sm:w-auto"
            onClick={() => navigate("/batch")}
          >
            <Plus size={16} />
            Update batch topic
          </button>
          <button
            className="flex items-center justify-center gap-1 border px-4 py-2 rounded-lg 
            dark:bg-white bg-black text-white dark:text-black text-sm 
            hover:opacity-90 transition-all w-full sm:w-auto"
            onClick={() => setOpen(true)}
            >
            <Plus size={16} />
            Add Notification
          </button>
            </div>
        </div>

        {/* Search Bar */}
        <div className="w-full sm:w-2/3 md:w-1/2 mx-auto sm:mx-0">
          <Searchbar
            placeholder="Search student name..."
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
        </div>

        {/* Main Tabs Section */}
        <Tabs defaultValue="overview" className="space-y-16">
          {/* Tabs Header */}
          <TabsList
            className="flex flex-wrap justify-center sm:justify-start gap-2 w-full 
                       sm:grid sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-7space-y-auto"
          >
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="students">Students</TabsTrigger>
            <TabsTrigger value="upload">Upload</TabsTrigger>
            <TabsTrigger value="resources">Resources</TabsTrigger>
            <TabsTrigger value="assignments">Assignments/Task</TabsTrigger>
            <TabsTrigger value="interview">Interview</TabsTrigger>
            <TabsTrigger value="ranking">Ranking</TabsTrigger>
          </TabsList>

          {/* Tabs Content */}
          <TabsContent value="overview" className="">
            <OverviewCards resourcesCount={resources.length} />
          </TabsContent>

          <TabsContent value="students">
            <StudentsSection searchTerm={searchTerm} />
          </TabsContent>

          <TabsContent value="upload">
            <UploadSection />
          </TabsContent>

          <TabsContent value="resources">
            <ResourcesSection />
          </TabsContent>

          <TabsContent value="assignments">
            <AssignmentsSection />
          </TabsContent>

          <TabsContent value="interview">
            <InterviewSection />
          </TabsContent>

          <TabsContent value="ranking"   >
            <ResizableSections />
          </TabsContent>
        </Tabs>
      </div>

      {/* Notification Modal */}
      <NotificationModal open={open} setOpen={setOpen} />
    </div>
  );
};

export default InstructorDashboard;
